/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-10-15 00:23:24
 * @LastEditTime: 2021-09-15 13:00:29
 * @LastEditors: 陈秀根
 */
import Http from './zyb-axios'
import api from './api'
import _ from 'lodash'
export const apis = _.mapValues(
  api,
  _.bind(_.mapValues, null, _, (v: any) => v + ``)
)
export default Http(apis)
